import { useTranslation } from 'react-i18next';
import Button from 'components/Button/Button';
import EmptyTaskManagement from 'components/EmptyTaskManagement/EmptyTaskManagement';
import ErrorDetailModal from 'components/ErrorDetailModal/ErrorDetailModal';
import Loader from 'components/Loader/Loader';
import Panel from 'components/Panel/Panel';
import { MATERIALITY_ASSESSMENT_STATUS_OPTIONS } from 'constants/general';
import { DELETE_MODAL_TITLES } from 'constants/interfaces';
import DeleteModal from 'pages/CompanyAdminPages/ValueChainMap/components/DeleteModal/DeleteModal';

import FilterBar from './components/FiltersBar/Filterbar';
import TableMaterialityAssessment from './components/TableMaterialityAssessment/TableMaterialityAssessment';

import type IMaterialityAssessment from './interfaces/IMaterialityAssessment';

import styles from './sass/MaterialityAssessment.module.scss';

function MaterialityAssessmentView({
  isEmptyList, loading, goToInitiateMaterialityAssessment, control, onSearchChange,
  onSortChange, onGetMoreItems, itemsList, hasNext, onEdit, onDelete,
  isDeleteModalOpen, onCloseDeleteModal, onDeleteSwimlaneConfirm, onResetOffset,
  openErrorDetailsModal, errorDetails, handleCloseErrorDetailsModal, handleGoLink,
  handleApprove, handleReject, showAction, isDisabledAccess, isCreateMaterialityAssessmentDisabled,
  isSignOff, isViewOnlyOrSignOff,
}: IMaterialityAssessment) {
  const { t } = useTranslation();

  return (
    <div className={styles.root}>
      <div className={styles.header}>
        <p>{t('materialityAssessment.title')}</p>
        {isEmptyList || loading || isCreateMaterialityAssessmentDisabled ? null : (
          <Button
            title={t('materialityAssessment.buttonTitle2')}
            onClick={goToInitiateMaterialityAssessment}
          />
        )}
      </div>
      {loading ? (
        <Panel className={styles.panel}>
          <Loader isPageLoading isFullLoader={false} />
        </Panel>
      ) : null}
      {isEmptyList && !loading ? (
        <Panel className={styles.panel}>
          <EmptyTaskManagement
            title={t('materialityAssessment.subTitle')}
            buttonTitle={t('materialityAssessment.buttonTitle')}
            buttonOnClick={goToInitiateMaterialityAssessment}
            disabledButton={isCreateMaterialityAssessmentDisabled}
          />
        </Panel>
      ) : null}
      {!isEmptyList && !loading ? (
        <div className={styles.content}>
          <FilterBar
            control={control}
            onSearchChange={onSearchChange}
            statusOption={MATERIALITY_ASSESSMENT_STATUS_OPTIONS}
            onResetOffset={onResetOffset}
          />
          <TableMaterialityAssessment
            control={control}
            items={itemsList}
            onSortChange={onSortChange}
            isLoading={loading}
            onEdit={onEdit}
            onDelete={onDelete}
            hasNext={hasNext}
            onGetMoreItems={onGetMoreItems}
            handleApprove={handleApprove}
            handleReject={handleReject}
            showAction={showAction}
            isDisabledAccess={isDisabledAccess}
            isSignOff={isSignOff}
            isViewOnlyOrSignOff={isViewOnlyOrSignOff}
          />
        </div>
      ) : null}
      <DeleteModal
        open={isDeleteModalOpen}
        onReject={onCloseDeleteModal}
        isLoading={false}
        name=""
        title={DELETE_MODAL_TITLES.DELETE_MA}
        onConfirm={onDeleteSwimlaneConfirm}
      />
      <ErrorDetailModal
        open={openErrorDetailsModal}
        onClose={handleCloseErrorDetailsModal}
        errorDetails={errorDetails}
        handleGoLink={handleGoLink}
      />
    </div>
  );
}

export default MaterialityAssessmentView;
